import { render, staticRenderFns } from "./CompanyRLSGroupWrapper.vue?vue&type=template&id=bd178e8a"
import script from "./CompanyRLSGroupWrapper.vue?vue&type=script&lang=js"
export * from "./CompanyRLSGroupWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports